"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Patient_Link = exports.Patient_LinkTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Element_1 = require("./RTTI_Element");
var Patient_LinkTypeKind;
(function (Patient_LinkTypeKind) {
    Patient_LinkTypeKind["_replacedBy"] = "replaced-by";
    Patient_LinkTypeKind["_replaces"] = "replaces";
    Patient_LinkTypeKind["_refer"] = "refer";
    Patient_LinkTypeKind["_seealso"] = "seealso";
})(Patient_LinkTypeKind = exports.Patient_LinkTypeKind || (exports.Patient_LinkTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Patient_Link = t.recursion('IPatient_Link', function () {
    return t.intersection([
        t.type({
            other: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            type: (0, EnumType_1.createEnumType)(Patient_LinkTypeKind, 'Patient_LinkTypeKind'),
            _type: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_Patient_Link.js.map